class GallerySlider extends HTMLElement {
    constructor() {
        super();
        this.isDesktop = screen.width > 1024;
    }

    connectedCallback() {
        if (this.isDesktop) return
        new Swiper(this.querySelector('.swiper-container'), {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });
    }
}

customElements.define('gallery-slider', GallerySlider);